var _dec, _dec2, _class, _Breadcrumb;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { isValidElement, cloneElement, Children, Component } from 'react';
import { View } from '@instructure/ui-view';
import { testable } from '@instructure/ui-testable';
import { withStyle } from '@instructure/emotion';
import { IconArrowOpenEndSolid } from '@instructure/ui-icons';
import { BreadcrumbLink } from './BreadcrumbLink';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { propTypes, allowedProps } from './props';
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/**
---
category: components
---
**/
let Breadcrumb = (_dec = withStyle(generateStyle, generateComponentTheme), _dec2 = testable(), _dec(_class = _dec2(_class = (_Breadcrumb = class Breadcrumb extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      this.ref = el;
    };
    this.addAriaCurrent = child => {
      const updatedChild = /*#__PURE__*/cloneElement(child, {
        'aria-current': 'page'
      });
      return updatedChild;
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props);
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2);
  }
  renderChildren() {
    const _this$props3 = this.props,
      styles = _this$props3.styles,
      children = _this$props3.children;
    const numChildren = Children.count(children);
    const inlineStyle = {
      maxWidth: `${Math.floor(100 / numChildren)}%`
    };
    let isAriaCurrentSet = false;
    return Children.map(children, (child, index) => {
      const isLastElement = index === numChildren - 1;
      if (/*#__PURE__*/isValidElement(child)) {
        const isCurrentPage = child.props.isCurrentPage || false;
        if (isAriaCurrentSet && isCurrentPage) {}
        if (isCurrentPage) {
          isAriaCurrentSet = true;
        }
      }
      return _jsxs("li", {
        css: styles === null || styles === void 0 ? void 0 : styles.crumb,
        style: inlineStyle,
        children: [!isAriaCurrentSet && isLastElement && child.props.isCurrentPage !== false ? this.addAriaCurrent(child) : child, index < numChildren - 1 && _jsx(IconArrowOpenEndSolid, {
          color: "auto",
          css: styles === null || styles === void 0 ? void 0 : styles.separator
        })]
      });
    });
  }
  render() {
    const styles = this.props.styles;
    return _jsx(View, {
      role: "navigation",
      as: "div",
      margin: this.props.margin,
      "aria-label": this.props.label,
      elementRef: this.handleRef,
      children: _jsx("ol", {
        css: styles === null || styles === void 0 ? void 0 : styles.breadcrumb,
        children: this.renderChildren()
      })
    });
  }
}, _Breadcrumb.displayName = "Breadcrumb", _Breadcrumb.componentId = 'Breadcrumb', _Breadcrumb.propTypes = propTypes, _Breadcrumb.allowedProps = allowedProps, _Breadcrumb.defaultProps = {
  size: 'medium',
  children: null
}, _Breadcrumb.Link = BreadcrumbLink, _Breadcrumb)) || _class) || _class);
export default Breadcrumb;
export { Breadcrumb, BreadcrumbLink };